module.exports = __webpack_public_path__ + "static/media/call-to-action.dae13958.jpg";